import Typography from "typography"
import theme from "typography-theme-bootstrap"

import { FONT_FAMILY_DEFAULT } from "../const"

const typography = new Typography({
  ...theme,
  headerFontFamily: FONT_FAMILY_DEFAULT,
  bodyFontFamily: FONT_FAMILY_DEFAULT,
})

export default typography
